import React, { useState } from "react";
import "./FormattedText.css";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FormattedText = ({ selectedRow }) => {
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const [iconRotation, setIconRotation] = useState(0);

  /**This function updates the state of the variable that tells us if the more info box is open and rotates the iconused to open it */
  const toggleInfo = () => {
    setIsInfoOpen(!isInfoOpen);
    setIconRotation(isInfoOpen ? 0 : 180);
  };

  const modifyURL = (url) => {
    if (url) {
      if (url.startsWith("DOI:")) {
        return "https://doi.org/" + url.substring(5);
      } else if (!url.startsWith("https://")) {
        return "https://doi.org/" + url;
      }
    }
    return url;
  };

  console.log(selectedRow);
  if (selectedRow[0].features[0].geometry) {
    console.log(selectedRow[0].features[0].geometry.coordinates);
  }
  if (!selectedRow) {
    return null;
  }

  const uniqueValues = {};

  /**This function sets the display property of the more info tab to block or none depending on the click  */
  const hideinfo = () => {
    const ele = document.getElementById("moreInfoTab");
    if (ele) {
      if (ele.style.display === "block") {
        ele.style.display = "none";
      } else {
        ele.style.display = "block";
      }
    }
  };

  selectedRow.forEach((e) => {
    const properties = e.features[0].properties;
    for (const key of Object.keys(properties)) {
      if (properties[key]) {
        if (!uniqueValues[key]) {
          uniqueValues[key] = [properties[key]];
        } else {
          uniqueValues[key].push(properties[key]);
        }
      }
      // console.log(uniqueValues);
    }
  });

  Object.keys(uniqueValues).forEach((key) => {
    uniqueValues[key] = new Set(uniqueValues[key]);
  });

  const formattedText = (
    <>
      {uniqueValues.country && (
        <span>
          This paper located in {Array.from(uniqueValues.country).join(", ")}{" "}
        </span>
      )}
      <span>serves to outline the mitigation methods taken to prevent </span>
      {uniqueValues.typeOfRisk && (
        <span>{Array.from(uniqueValues.typeOfRisk).join(", ")}</span>
      )}
      {uniqueValues.mitigationMeasure && (
        <span>
          {" "}
          using {Array.from(uniqueValues.mitigationMeasure).join(", ")}
        </span>
      )}
      {uniqueValues.naturalEnvironment && (
        <span>
          in the {Array.from(uniqueValues.naturalEnvironment).join(", ")}{" "}
          environments
        </span>
      )}
      {uniqueValues.period && (
        <span>
          {" "}
          during the {Array.from(uniqueValues.period).join(", ")} period at
        </span>
      )}
      {uniqueValues.pilotArea && (
        <span> {Array.from(uniqueValues.pilotArea).join(", ")}.</span>
      )}
      {uniqueValues.typeOfMonument && (
        <span>
          {" "}
          The research focuses on the{" "}
          {Array.from(uniqueValues.typeOfMonument).join(", ")} monument
        </span>
      )}
      {uniqueValues.siteContext && (
        <span>
          {" "}
          in a {Array.from(uniqueValues.siteContext).join(", ")} context.
        </span>
      )}
    </>
  );

  const propertiesInfo = selectedRow[0].features[0].properties;
  const moreInfo = (
    <div className="moreInfoText">
      {/* <h2>More Info:</h2> */}
      {/* <ul>
        {Object.entries(propertiesInfo).map(([key, value]) => (
          <li key={key}>
            <strong>{key}:</strong> {value}
          </li>
        ))}
      </ul> */}
      <table className="paper-info-table">
        <tbody>
          {Object.entries(propertiesInfo).map(([key, value], index) => (
            <tr key={index}>
              <td>{key}</td>
              <td>
                {key === 'url' ? (
                  <a href={modifyURL(value)} target="_blank" rel="noopener noreferrer">
                    {value}
                  </a>
                ) : (
                  value
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="paper-card">
      <p>
        {uniqueValues.title && (
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>
            {Array.from(uniqueValues.title).join("")}
          </p>
        )}
      </p>
      <p>{formattedText}</p>
      <p>
        {/* For more details, click{" "} */}
        {console.log(uniqueValues.url)}
        <a
          href={modifyURL(Array.from(uniqueValues.url)[0])}
          target="_blank"
          rel="noopener noreferrer"
        >
          Paper link
        </a>
        .
      </p>
      <button
        className="info-button"
        onClick={() => {
          {
            hideinfo();
            toggleInfo();
          }
        }}
      >
        Read More
        <FontAwesomeIcon
          icon={faChevronDown}
          style={{
            transform: `rotate(${iconRotation}deg)`,
            transition: "transform 0.2s ease",
          }}
        />
      </button>
      <div
        className="MoreInfoTab"
        id="moreInfoTab"
        style={{ display: isInfoOpen ? "block" : "none" }}
      >
        {moreInfo}
      </div>
    </div>
  );
};

export default FormattedText;
